webpackJsonp([158396747691188],{

/***/ "./assets/sperm.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sperm.13c6e66f.png";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/news/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  max-height: 60px;\n  max-width: 140px;\n  padding: 20px;\n  filter: grayscale(100%);\n  mix-blend-mode: multiply;\n  transition: filter 300ms;\n  :hover {\n    filter: grayscale(0%);\n  }\n"], ["\n  max-height: 60px;\n  max-width: 140px;\n  padding: 20px;\n  filter: grayscale(100%);\n  mix-blend-mode: multiply;\n  transition: filter 300ms;\n  :hover {\n    filter: grayscale(0%);\n  }\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Post = __webpack_require__("./src/components/Post.js");
	
	var _sperm = __webpack_require__("./assets/sperm.png");
	
	var _sperm2 = _interopRequireDefault(_sperm);
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LogoRow = _styledComponents2.default.div(_templateObject);
	
	var LogoImg = _styledComponents2.default.img(_templateObject2);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var content = (0, _selectors.getGraphNode)(data, "NewsPage");
	  var posts = content.blogPost;
	  posts.sort(function (a, b) {
	    return new Date(b.publishDate) > new Date(a.publishDate);
	  });
	  var press = content.pressMentions;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: "Contraline News",
	        meta: [{ name: "Contraline", content: "News" }]
	      },
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	    ),
	    _react2.default.createElement(_NavBar2.default, { color: "dark", background: "greyLight" }),
	    _react2.default.createElement(
	      _Background2.default,
	      { color: "greyLight", fixed: true },
	      _react2.default.createElement(
	        _Responsive.HideMobile,
	        null,
	        _react2.default.createElement(
	          _Section2.default,
	          { noBorder: true, fixed: true, vPad: false },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            null,
	            _react2.default.createElement(_Post.PostFeature, { post: posts[0] })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { fixed: true, style: { paddingBottom: "2.8rem" } },
	        _react2.default.createElement(
	          _typography.H5,
	          {
	            align: "center",
	            style: { paddingBottom: "0.5rem", fontWeight: 700 }
	          },
	          "Featured In"
	        ),
	        _react2.default.createElement(
	          LogoRow,
	          null,
	          press.map(function (p) {
	            return _react2.default.createElement(
	              "a",
	              { href: p.link },
	              _react2.default.createElement(LogoImg, { src: p.logo.file.url })
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { fixed: true },
	        _react2.default.createElement(
	          _Responsive.HideMobile,
	          null,
	          _react2.default.createElement(_Pad2.default, { h: 2, v: 1 }),
	          posts.slice(1).map(function (post, index) {
	            return _react2.default.createElement(_Post.PostThumbnail, { post: post, index: index });
	          })
	        ),
	        _react2.default.createElement(
	          _Responsive.ShowMobile,
	          null,
	          posts.map(function (post, index) {
	            return _react2.default.createElement(_Post.PostThumbnail, { post: post, index: index });
	          })
	        )
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-index-js-10a44779dc6f0222d3d8.js